import React from 'react'
import { Alert, Box, Button } from '@mui/material'
import { useNamesTranslation } from '../hooks/useNamesTranslation'
import { messageText } from '../model/messageText'

const ACTION_LABEL = {
  PRESENCE_ONLY: 'Correct only the presence',
  RELOAD_TIMELINE: 'Reload the timeline',
  TRY_AGAIN: 'Try again'
}

/**
 * A message of the catalog (RN75, RN78): its text, the second sentence of RH-19 when it has one, and the buttons that help
 * (`actions`: PRESENCE_ONLY, RELOAD_TIMELINE, TRY_AGAIN). `onAction(name)` runs the one pressed. `renderText(message)`
 * replaces the plain text (a message that names corrections shows them as links).
 */
const UiMessageAlert = ({ message, severity = 'error', onAction, disabled = false, renderText }) => {
  const { t_ } = useNamesTranslation()
  const actions = message.actions || []
  return (
    <Alert severity={severity} role='alert' data-testid='ui-message'>
      <Box>{renderText ? renderText(message) : messageText(message, t_)}</Box>
      {actions.length > 0 && (
        <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {actions.map((action) => (
            <Button key={action} size='small' variant='outlined' color='inherit' disabled={disabled} onClick={() => onAction(action)}>{t_(ACTION_LABEL[action])}</Button>
          ))}
        </Box>
      )}
    </Alert>
  )
}

export default UiMessageAlert
